<div class="career-listing">
  <!-- Loading State -->
  @if (isLoading) {
    <div class="text-center py-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3">Loading job listings...</p>
    </div>
  }

  <!-- Job List -->
  @if (!isLoading && jobs && jobs.length > 0) {
    <div>
      @for (job of jobs; track trackByJobId($index, job)) {
        <div class="career-item">
          <div class="job-card">
            <h3 class="job-title">{{ job.title }}</h3>
            <p class="job-department">{{ job.department }}</p>
            <p class="job-location">{{ job.location }}</p>
            <p class="job-description">{{ job.description }}</p>
            <a [routerLink]="['/join-our-tribe', job.slug]" class="btn btn-primary">
              View Details
            </a>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="empty-state text-center py-5">
      <h2 class="mb-2">No Openings Found</h2>
      <p class="text-muted">Currently there are no open positions in this department. Please check back later.</p>
    </div>
  }

</div>
